module.exports = __webpack_public_path__ + "static/media/notice_information.6723e5c0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/gpi/documents/adhesion/notice_information.pdf
// module id = 844
// module chunks = 40